<template>
    
    <div class="h-20 mb-2 border-b flex flex-row relative">

        <div class="h-full w-1/3 p-2 flex flex-row justify-center items-center">
        
            <div class="h-full w-full shadow rounded-lg bg-white" :style="'background-image: url(' + data.image + '); background-repeat: no-repeat; background-size: cover; background-position: center;'"></div>

        </div>

        <div class="h-full w-2/3 flex flex-col justify-center items-start px-2">

            <div class="h-6 w-6 rounded-full absolute top-0 left-0 bg-green-500 mt-1 ml-1 flex flex-col justify-center items-center">
                <span class="text-white text-sm font-semibold">{{data.quantity}}</span>
            </div>
        
            <span class="text-black text-md font-semibold">{{data.product_name}}</span>
            <span class="text-blue-500 text-sm -mt-1">{{data.price}}€</span>
            <span class="text-blue-500 ml-auto text-lg font-semibold mt-auto">{{data.total}}€</span>
        
        </div>

    </div>

</template>

<script>
export default {
    props:['data']
}
</script>